import { Router } from '@angular/router';
import { ChangeDetectorRef, Component, Input, OnInit, ViewChild } from '@angular/core';
import saveAs from 'file-saver';
import { MenuItem, MessageService } from 'primeng/api';
import { first } from 'rxjs';
import { DepartmentAppVerificationModel } from 'src/app/models/department-app-verification.model';
import { Table } from 'primeng/table';
import { DepartmentDashboardService } from 'src/app/services/department-dashboard.service';
import { BankDetail } from '../../registration/bank-details/bankDetails';
import { CryptoJsService } from 'src/app/services/crypto-js.service';
import { DashboardService } from 'src/app/services/dashboard.service';
import { ActivityRecordService } from 'src/app/services/activity-record.service';

@Component({
  selector: 'app-year-wise-progress',
  templateUrl: './year-wise-progress.component.html',
  styleUrls: ['./year-wise-progress.component.scss']
})
export class YearWiseProgressComponent implements OnInit {
  @ViewChild('yearwiseProgressTable', { static: true }) public estVerificationTable: Table;
  @ViewChild('yearwiseProgress2Table', { static: true }) public yearwiseProgress2Table: Table;

  addBankDialog: boolean;
  fileName = 'ExcelSheet.xlsx';
  bankAccount: BankDetail;
  waterFlow: any;
  selectedBankAccounts: BankDetail[];
  finalArray = [];
  submitted: boolean;
  districtConstituencyItems: MenuItem[];
  canalAndTubewellItems: MenuItem[];
  vendorEstVerificationItems: MenuItem[];
  cols: (
    | { field: string; header: string; customExportHeader: string }
    | { field: string; header: string; customExportHeader?: undefined }
  )[];
  exportColumns: { title: string; dataKey: string }[];
  farmerId: any;
  bankList: any;
  filteredBankList: any[];
  appVerificationModel: DepartmentAppVerificationModel[];
  miDetailsByAppId: any;
  _appID: any;

  ipAddress: any;
  public userID: any;
  public status: any;
  districtConsistencyList: any[];
  canalTubewellReportList: any[];
  canalTubewellList: any;
  disctrictConsistenceWiseData: any;
  WaterSoucreListData: any;
  constructor(
    private messageService: MessageService,
    private deptDashBoardService: DepartmentDashboardService,
    private router: Router,
    private dashboard: DashboardService,
    private cryptoJsService: CryptoJsService,
    private activityRecordService: ActivityRecordService,
    public cd: ChangeDetectorRef
  ) { }
  ngOnChanges(values) {
    
  }
  ngOnInit() {
    let sessionToken = sessionStorage.getItem('token');
    let payload = atob(JSON.parse(sessionToken).authToken?.split('.')[1]);
    this.userID = JSON.parse(payload)?.sub;
    this.loadData();
    // this.estVerificationTable.filters['Status_Ar'] = [
    //   { value: 'P', matchMode: 'startsWith', operator: 'and' },
    // ];
    // this.canalAndTubeWell
    // this.districtAndConsistence
    this.districtConstituencyItems = [
      {
        label: 'Download excel',
        icon: 'pi pi-fw pi-download',
        command: () => {
          this.exportExcel(this.disctrictConsistenceWiseData, 'District and constituency wise detail');
        },
      },
      {
        label: 'Download Pdf',
        icon: 'pi pi-fw pi-download',
        command: () => {
          this.downloadSheetAsPdf(
            this.disctrictConsistenceWiseData,
            'District and constituency wise detail'
          );
        },
      },
    ];
    this.canalAndTubewellItems = [
      {
        label: 'Download excel',
        icon: 'pi pi-fw pi-download',
        command: () => {
          this.exportExcel1(this.WaterSoucreListData, 'Micro Irrigation System (Canal and Tube Well Based Report)');
        },
      },
      {
        label: 'Download Pdf',
        icon: 'pi pi-fw pi-download',
        command: () => {
          this.downloadSheetAsPdf1(
            this.WaterSoucreListData,
            'Micro Irrigation System (Canal and Tube Well Based Report)'
          );
        },
      },
    ];
  }

  onFiltering(event: any) {
    console.log('Filtered value: ' + JSON.stringify(event.filters));
  }
  loadData() {
    this.deptDashBoardService.GetRealTimeDataofPDMCScheme().pipe(first()).subscribe({
      next: (data) => {
        this.CanalAndTubeWellBasedReport(data)
        this.consistenceWisedDataCalculation(data)
      },
      error: (err) => {
        this.activityRecordService.activityRecord(this.userID, 'Canal and tubewell', 'District and consistence wise data Approval', new Date(), err);
        this.messageService.add({
          severity: 'error',
          summary: 'Error Message',
          detail: 'Data error! District and consistence wise data not loaded.',
        });
      },
    });
  }
  CanalAndTubeWellBasedReport(data) {
    let waterSourceObj = {}
    this.canalTubewellList = data;
    for (let index = 0; index < this.canalTubewellList.length; index++) {
      if (waterSourceObj[this.canalTubewellList[index].Source_Name]) {
        waterSourceObj[this.canalTubewellList[index].Source_Name].push(this.canalTubewellList[index])
      } else if (!waterSourceObj[this.canalTubewellList[index].Source_Name]) {
        waterSourceObj[this.canalTubewellList[index].Source_Name] = []
        waterSourceObj[this.canalTubewellList[index].Source_Name].push(this.canalTubewellList[index])
      }
    }
    let waterSourceArray = Object.keys(waterSourceObj)
    let waterSourceWisedData = [];
    for (let index = 0; index < waterSourceArray.length; index++) {
      let waterSourceArrayList = waterSourceObj[waterSourceArray[index]]
      let verifiedAreaCount = 0;
      let incompleteAreaCount = 0;
      let verifiedApps = 0;
      let subsidyDisbursedDate = 0;
      let disbursedAmount = 0;
      let Area = 0;
      let Source_Name: any;
      for (let l = 0; l < waterSourceArrayList.length; l++) {
          Source_Name = waterSourceArrayList[l].Source_Name
          if (waterSourceArrayList[l].TotalArea) {
            Area = Area + (waterSourceArrayList[l].TotalArea ? waterSourceArrayList[l].TotalArea : 0)
          }
          if (waterSourceArrayList[l].Status_Ar == 'A') {
            verifiedApps = verifiedApps + 1
            verifiedAreaCount = verifiedAreaCount + (waterSourceArrayList[l].TotalArea ? waterSourceArrayList[l].TotalArea : 0)
          }
          if ((waterSourceArrayList[l].Status_Ar == 'CP') || (waterSourceArrayList[l].Status_Ar == 'RP')) {
            incompleteAreaCount = incompleteAreaCount + (waterSourceArrayList[l].TotalArea ? waterSourceArrayList[l].TotalArea : 0)
          }
          if (waterSourceArrayList[l].SubsidyDisbursedDate) {
            subsidyDisbursedDate = subsidyDisbursedDate + (waterSourceArrayList[l]).length
          }
          if(waterSourceArrayList[l].DisbursedAmount) {
            disbursedAmount = disbursedAmount + (waterSourceArrayList[l].DisbursedAmount ? waterSourceArrayList[l].DisbursedAmount : 0)
          }
      }
      const Obj = {
        Source_Name: Source_Name,
        Verified_Apps : verifiedApps,
        Verified_Area_Count: verifiedAreaCount ? verifiedAreaCount.toFixed(2) : 0,
        Under_Process_of_Installation : incompleteAreaCount ? incompleteAreaCount.toFixed(2) : 0,
        Assistance_Disbursed : subsidyDisbursedDate,
        Area: Area ? Area.toFixed(2) : 0,
        Disbursed_Amount: disbursedAmount,
        Noof_Benficiaries : verifiedApps
      }
      waterSourceWisedData.push(Obj);
    }
    waterSourceWisedData.forEach(e=>{
      e.Area=parseFloat(e.Area)
      e.Under_Process_of_Installation=parseFloat(e.Under_Process_of_Installation);
      e.Verified_Area_Count=parseFloat(e.Verified_Area_Count)
    })
    this.WaterSoucreListData = waterSourceWisedData
    this.cd.detectChanges();
    this.cd.reattach()
  }
  consistenceWisedDataCalculation(data) {
    let constitutionsObj = {}
    if (data && data.length > 0) {
      this.districtConsistencyList = data
      for (let index = 0; index < this.districtConsistencyList.length; index++) {
        if (constitutionsObj[this.districtConsistencyList[index].Constituency]) {
          constitutionsObj[this.districtConsistencyList[index].Constituency].push(this.districtConsistencyList[index])
        } else if (!constitutionsObj[this.districtConsistencyList[index].Constituency]) {
          constitutionsObj[this.districtConsistencyList[index].Constituency] = []
          constitutionsObj[this.districtConsistencyList[index].Constituency].push(this.districtConsistencyList[index])
        }
      }
      let constitutionkeysArray = Object.keys(constitutionsObj)
      let tempConsistenceWisedData = [];
      for (let index = 0; index < constitutionkeysArray.length; index++) {
        let constituteArrayList = constitutionsObj[constitutionkeysArray[index]]
        let statusArray = {}
        let verifiedAreaCount = 0;
        let incompleteAreaCount = 0;
        let EstimateCreated = 0;
        let EstimateApproved = 0;
        let BillsofQuantityUploaded = 0;
        let PhysicalverificationCompleted = 0;
        let AssistanceDisbursed = 0;
        let AssistanceDisbursedArea = 0
        let AssistanceDisbursedAmount = 0
        let Area = 0;
        let source_id: any;
        let count: any;
        for (let l = 0; l < constituteArrayList.length; l++) {
          if (statusArray[constituteArrayList[l].Status_Ar]) {
            source_id = constituteArrayList[l].Source_ID
            if (constituteArrayList[l].APP_ID) {
              statusArray[constituteArrayList[l].Status_Ar].push(constituteArrayList[l])
            }
            if (!constituteArrayList[l].APP_ID) {
               count = constituteArrayList[l]
            }
            if (constituteArrayList[l].TotalArea) {
              Area = Area + (constituteArrayList[l].TotalArea ? constituteArrayList[l].TotalArea : 0)
            }
            if (constituteArrayList[l].Status_Ar == 'A') {
              verifiedAreaCount = verifiedAreaCount + (constituteArrayList[l].TotalArea ? constituteArrayList[l].TotalArea : 0)
            } if ((constituteArrayList[l].Status_Ar == 'CP') || (constituteArrayList[l].Status_Ar == 'RP')) {
              incompleteAreaCount = incompleteAreaCount + (constituteArrayList[l].TotalArea ? constituteArrayList[l].TotalArea : 0)
            }
            if (constituteArrayList[l].Estimatedate) {
              EstimateCreated = EstimateCreated + 1
            }
            if (constituteArrayList[l].EstimateApprovalDate) {
              EstimateApproved = EstimateApproved + 1
            }
            if (constituteArrayList[l].BoqUploaddate) {
              BillsofQuantityUploaded = BillsofQuantityUploaded + 1
            }
            if (constituteArrayList[l].PVDate) {
              PhysicalverificationCompleted = PhysicalverificationCompleted + 1
            }
            if (constituteArrayList[l].SubsidyDisbursedDate) {
              AssistanceDisbursed = AssistanceDisbursed + 1
            }
            if (constituteArrayList[l].AssistanceDisbursedArea) {
              AssistanceDisbursedArea = AssistanceDisbursedArea + (constituteArrayList[l].TotalArea ? constituteArrayList[l].TotalArea : 0)
            }
            if (constituteArrayList[l].AssistanceDisbursedAmount) {
              AssistanceDisbursedAmount = AssistanceDisbursedAmount + (constituteArrayList[l].DisbursedAmount ? constituteArrayList[l].DisbursedAmount : 0)
            }
          } else {
            statusArray[constituteArrayList[l].Status_Ar] = []
            if (constituteArrayList[l].APP_ID) {
              statusArray[constituteArrayList[l].Status_Ar].push(constituteArrayList[l])
            }
            if (!constituteArrayList[l].APP_ID) {
               count = constituteArrayList[l]
            }
            if (constituteArrayList[l].TotalArea) {
              Area = Area + (constituteArrayList[l].TotalArea ? constituteArrayList[l].TotalArea : 0)
            }
            if (constituteArrayList[l].Status_Ar == 'A') {
              verifiedAreaCount = verifiedAreaCount + (constituteArrayList[l].TotalArea ? constituteArrayList[l].TotalArea : 0)
            }
            if ((constituteArrayList[l].Status_Ar == 'CP') || (constituteArrayList[l].Status_Ar == 'RP')) {
              incompleteAreaCount = incompleteAreaCount + (constituteArrayList[l].TotalArea ? constituteArrayList[l].TotalArea : 0)
            }
            if (constituteArrayList[l].Estimatedate) {
              EstimateCreated = EstimateCreated + 1
            }
            if (constituteArrayList[l].EstimateApprovalDate) {
              EstimateApproved = EstimateApproved + 1
            }
            if (constituteArrayList[l].BoqUploaddate) {
              BillsofQuantityUploaded = BillsofQuantityUploaded + 1
            }
            if (constituteArrayList[l].PVDate) {
              PhysicalverificationCompleted = PhysicalverificationCompleted + 1
            }
            if (constituteArrayList[l].SubsidyDisbursedDate) {
              AssistanceDisbursed = AssistanceDisbursed + 1
            }
            if (constituteArrayList[l].AssistanceDisbursedArea) {
              AssistanceDisbursedArea = AssistanceDisbursedArea + (constituteArrayList[l].TotalArea ? constituteArrayList[l].TotalArea : 0)
            }
            if (constituteArrayList[l].AssistanceDisbursedAmount) {
              AssistanceDisbursedAmount = AssistanceDisbursedAmount + (constituteArrayList[l].DisbursedAmount ? constituteArrayList[l].DisbursedAmount : 0)
            }
          }
        }
        const Obj = {
          Source_id: source_id,
          Application_recevied: constituteArrayList.length,
          District: constituteArrayList[0].District,
          Constituency: constituteArrayList[0].Constituency,
          Area: Area ? Area.toFixed(2) : 0,
          Approved: statusArray['A'] ? statusArray['A'].length : 0,
          Rejected: statusArray['R'] ? statusArray['R'].length : 0,
          Pending: statusArray['P'] ? statusArray['P'].length : 0,
          Incomplete: (statusArray['CP'] ? statusArray['CP'].length : 0) + (statusArray['RP'] ? statusArray['RP'].length : 0),
          Verified_Area_Count: verifiedAreaCount ? verifiedAreaCount.toFixed(2) : 0,
          Incomplete_Area_count: incompleteAreaCount,
          Estimate_Created: EstimateCreated,
          Estimate_Approved: EstimateApproved,
          Billsof_Quantity_Uploaded: BillsofQuantityUploaded,
          Physical_Verification_Completed: PhysicalverificationCompleted,
          Assistance_Disbursed: AssistanceDisbursed,
          Assistance_Disbursed_Area: AssistanceDisbursedArea,
          Assistance_Disbursed_Amount: AssistanceDisbursedAmount,
          NoOf_Benficiary : statusArray['A'] ? statusArray['A'].length : 0,
        }
        tempConsistenceWisedData.push(Obj)
      }
      tempConsistenceWisedData.forEach(e=>{
        e.Area=parseFloat(e.Area)
        e.Verified_Area_Count=parseFloat(e.Verified_Area_Count)
      })
      this.disctrictConsistenceWiseData = tempConsistenceWisedData
      this.cd.detectChanges();
      this.cd.reattach()
    }

  }
  refreshTable() {
    sessionStorage.removeItem('District and consistence wise data Approval ');
    this.loadData();
  }
  downloadSheetAsPdf(modelData, filename) {
    this.cols = [
      { field: 'Source_id', header: 'SI' },
      { field: 'District', header: 'Disctrict' },
      { field: 'Constituency', header: 'Constituency' },
      { field: 'Application_recevied', header: 'App receieved' },
      { field: 'Area', header: 'Area' },
      { field: 'Approved', header: 'Verified App' },
      { field: 'Verified_Area_Count', header: 'Area' },
      { field: 'Incomplete', header: 'Incomplete App' },
      { field: 'Rejected', header: 'Rejected App' },
      { field: 'Pending', header: 'Pending App' },
      { field: 'Estimate_Created', header: 'Estimate Create' },
      { field: 'Estimate_Approved', header: 'Estimate Approved' },
      { field: 'Billsof_Quantity_Uploaded', header: 'Bills od Quantity Uploaded' },
      { field: 'Physical_Verification_Completed', header: 'Physical Verification Completed' },
      { field: 'Assistance_Disbursed', header: 'Assistance Disbursed' },
      { field: 'Assistance_Disbursed_Area', header: 'Area' },
      { field: 'Assistance_Disbursed_Amount', header: 'Amount' },
      { field: 'Approved', header: 'No. of Benficiary' }

    ];

    this.exportColumns = this.cols.map((col) => ({
      title: col.header,
      dataKey: col.field,
    }));

    import('jspdf').then((jsPDF) => {
      import('jspdf-autotable').then((x) => {
        const doc = new jsPDF.default(0, 0);
        doc.autoTable(this.exportColumns, modelData);
        doc.save(`${filename}.pdf`);
      });
    });
  }

  hideDialog() {
    this.addBankDialog = false;
    this.submitted = false;
  }

  printForm(appId, statusCode) {
    if (appId) {
      this.dashboard
        .getMIDetailByAppID(appId)
        .pipe(first())
        .subscribe({
          next: (res) => {
            let statusCodeEncrypted = this.cryptoJsService.Encrypt(statusCode);
            this.router.navigate(
              [
                'department',
                'print',
                appId,
                res[0]?.VendorId,
                res[0]?.ProgId,
                res[0]?.User_ID,
                res[0]?.AutoId,
              ],
              { queryParams: { statusCode: statusCodeEncrypted } }
            );
          },
          error: (err) => {
            console.log('error', err);
            this.activityRecordService.activityRecord(this.userID, 'View District and consistence wise data Approval', appId, new Date(), err);
            this.messageService.add({
              severity: 'error',
              summary: 'Error Message',
              detail: err,
            });
          }
        });
    }
  }

  exportExcel(modelData, filename) {
    if (!modelData) {
      modelData = [];
    }
    import('xlsx').then((xlsx) => {
      let dataToSave = modelData.map((d: any) => {
        return {
          'SI': d.Source_id,
          'Disctrict': d.Application_recevied,
          'Constituency': d.District,
          'App receieved': d.Constituency,
          'Area': d.Area,
          'Verified App': d.Verified_Area_Count,
          'Verified Area': d.Approved,
          'Incomplete App': d.Rejected,
          'Rejected App': d.Pending,
          'Pending App': d.Incomplete,
          'Estimate Create': d.Estimate_Created,
          'Estimate Approved': d.Estimate_Approved,
          'Bills od Quantity Uploaded': d.Billsof_Quantity_Uploaded,
          'Physical Verification Completed': d.Physical_Verification_Completed,
          'Assistance Disbursed': d.Assistance_Disbursed,
          'Assistance Disbursed Area': d.Assistance_Disbursed_Area,
          'Amount': d.Assistance_Disbursed_Amount,
          'No. of Benficiary': d.Approved
        };
      });
      const worksheet = xlsx.utils.json_to_sheet(dataToSave);
      const workbook = { Sheets: { data: worksheet }, SheetNames: ['data'] };
      const excelBuffer: any = xlsx.write(workbook, {
        bookType: 'xlsx',
        type: 'array',
      });
      this.saveAsExcelFile(excelBuffer, filename);
    });
  }
  exportExcel1(modelData, filename) {
    if (!modelData) {
      modelData = [];
    }
    import('xlsx').then((xlsx) => {
      let dataToSave = modelData.map((d: any) => {
        return {
          "Water Source" : d.Source_Name,
          'Application Verified and Eligible for Assistance': d.Verified_Apps,
          'MI Area (In Acre)': d.Verified_Area_Count,
          'Application under process of Installation': d.Under_Process_of_Installation,
          'Assistance disbursed': d.Assistance_Disbursed,
          'Area (In Acre)': d.Area,
          'Amount (Rs. In lakh)': d.Disbursed_Amount,
          'No. of Beneficiary': d.Verified_Apps,
        };
      });
      const worksheet = xlsx.utils.json_to_sheet(dataToSave);
      const workbook = { Sheets: { data: worksheet }, SheetNames: ['data'] };
      const excelBuffer: any = xlsx.write(workbook, {
        bookType: 'xlsx',
        type: 'array',
      });
      this.saveAsExcelFile(excelBuffer, filename);
    });
  }
  downloadSheetAsPdf1(modelData, filename) {
    this.cols = [
      { field: 'Source_Name', header: 'Water Source' },
      { field: 'Verified_Apps', header: 'Application Verified and Eligible for Assistance' },
      { field: 'Verified_Area_Count', header: 'MI Area (In Acre)' },
      { field: 'Under_Process_of_Installation', header: 'Application under process of Installation' },
      { field: 'Assistance_Disbursed', header: 'Assistance disbursed' },
      { field: 'Area', header: 'Area (In Acre)' },
      { field: 'Disbursed_Amount', header: 'Amount (Rs. In lakh)' },
      { field: 'Verified_Apps', header: 'No. of Beneficiary' },
    ];

    this.exportColumns = this.cols.map((col) => ({
      title: col.header,
      dataKey: col.field,
    }));

    import('jspdf').then((jsPDF) => {
      import('jspdf-autotable').then((x) => {
        const doc = new jsPDF.default(0, 0);
        doc.autoTable(this.exportColumns, modelData);
        doc.save(`${filename}.pdf`);
      });
    });
  }
  saveAsExcelFile(buffer: any, fileName: string): void {
    import('file-saver').then((FileSaver) => {
      let EXCEL_TYPE =
        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
      let EXCEL_EXTENSION = '.xlsx';
      const data: Blob = new Blob([buffer], {
        type: EXCEL_TYPE,
      });
      saveAs(
        data,
        fileName + '_export_' + new Date().getTime() + EXCEL_EXTENSION
      );
    });
  }

  rowBackgroundColor(row) {
    if (row.Status_Ar == 'P') {
      if (row.PendingCompletedDays <= -2) {
        return '#ff8080';
      } else if (row.PendingCompletedDays == -1) {
        return '#ffc966';
      }
    } else if (row.Status_Ar == 'C' || row.Status_Ar == 'A') {
      if (row.PendingCompletedDays >= -1) {
        return '#99e699';
      } else if (row.PendingCompletedDays <= -2) {
        return '#ffb3b3';
      }
    } else return '#ffffff';
  }
}

